module.exports = "<topups-page></topups-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/topups.html
// module id = 1437
// module chunks = 0